import { Component } from '@angular/core';
import { InputTextControlComponent } from '../input-text-control/input-text-control.component';

@Component({
  selector: 'app-input-number-control',
  templateUrl: './input-number-control.component.html',
  styleUrls: ['./input-number-control.component.scss']
})
export class InputNumberControlComponent {
  
}
